import * as L from 'leaflet';

const normalOpacity = 1.0;
const highlightOpacity = 0.38;

/**
 * Handler functions helping kp-map-features controller
 */

export const setSelected = (id: string | null, markers: L.Marker[]) => {
    const select = (parentId: string) => {
        markers.forEach((marker: L.Marker) => {
            if (marker.feature.properties.parent === parentId) {
                select(marker.feature.properties.id);
            }
            if (marker.feature.properties.id === parentId) {
                marker.setOpacity(highlightOpacity);
            }
        });
    };
    markers.forEach((marker: L.Marker) => {
        marker.setOpacity(normalOpacity);
    });
    select(id);
};

export const moveChildMarkers = (id: string | null, markers: L.Marker[], diff: L.LatLng) => {
    const move = (parentId: string) => {
        markers.forEach((marker: L.Marker) => {
            if (marker.feature.properties.parent === parentId) {
                move(marker.feature.properties.id);
            }
        });
        const marker = markers.find((m) => m.feature.properties.id === parentId);

        marker.setLatLng(L.latLng(marker.getLatLng().lat + diff.lat, marker.getLatLng().lng + diff.lng));
    };
    move(id);
};
